<template>
  <div>
    <div class="landscape-block-wrapper" :class="{fadeIn:show}">
      <div class="w-100 text-center content-wrapper">
        <div class="message-1">PLEASE ROTATE YOUR PHONE</div>
        <div class="icon-rotate"><icon-rotate width="70" height="70"></icon-rotate></div>
        <div class="message-2">This experience is best enjoyed <br> in portrait</div>
      </div>

      <div class="invader">
        <fall-invader width="262" height="79"></fall-invader>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import IconRotate from 'static/svg/rotate.svg'
  import FallInvader from 'static/svg/fall_invader.svg'

  export default {
    components: {
      IconRotate,
      FallInvader,
    },
    data() {
      return {
        screenDimension: {},
        show: false,
      }
    },
    mounted() {
      window.addEventListener('orientationchange', this.orientationchange)
      this.orientationchange()
    },
    destroyed() {
      window.removeEventListener('orientationchange', this.orientationchange)
    },
    methods: {
      ...mapActions([
        'enableLandscapeBlock',
      ]),
      orientationchange() {
        switch (window.orientation) {
          case -90:
          case 90:
            this.foreShowLandscapeBlock(true)
            break
          default:
            this.foreShowLandscapeBlock(false)
            break
        }
      },
      foreShowLandscapeBlock(toggle) {
        this.enableLandscapeBlock(toggle)
        this.show = toggle
      },
    },
  }
</script>
<style lang="scss" scoped>
  .landscape-block-wrapper{
    position: fixed;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    height: var(--window-height, 100vh);
    background: rgba(0, 0, 0, 1);
    top: 0;
    display: none;
    pointer-events: none;
    .content-wrapper {
      padding-top: rem-calc(40);
      .message-1 {
        text-shadow: 2px 1px 0px rgba(248, 0, 142, 1);
        font-family: $silkscreen;
        font-size: rem-calc(24);
        font-weight: bold;
        color: rgba(24, 255, 255, 1);
      }
      .message-2 {
        font-family: $barlow;
        font-size: rem-calc(18);
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }
      .icon-rotate {
        fill: $rose;
        padding: rem-calc(23) 0;
      }
    }
    .invader {
      fill: #19ffff;
      position: absolute;
      bottom: 0;
      padding-left: rem-calc(44);
      svg {
        display:inherit;
      }
    }
    &.fadeIn {
      display: block;
      .content-wrapper, .invader {
        animation: fadeIn 0.5s forwards;
      }
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// LandscapeBlock.vue?7e795847